import type { ServiceType } from '@/pages/home/hooks/useWhatsApp';

interface FinalCTAProps {
  onOpenWhatsApp: (service?: ServiceType) => void;
}

export default function FinalCTA({ onOpenWhatsApp }: FinalCTAProps) {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-4xl mx-auto text-center">
        <div className="reveal">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-6">
            İŞLETMENİZ İÇİN
            <br />
            DOĞRU CATERING ÇÖZÜMÜNÜ BULALIM
          </h2>
          <p className="font-body text-foreground-600 text-base md:text-lg max-w-2xl mx-auto mb-10">
            Kaç kişilik hizmete ihtiyacınız olduğunu bize yazın, size özel teklifinizi öğrenin.
          </p>
          <button
            onClick={() => onOpenWhatsApp()}
            className="btn-primary text-base px-12 py-5 mb-4"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            WHATSAPP&apos;TAN TEKLİF AL
          </button>
          <p className="font-label text-foreground-500 text-sm">
            0542 776 2227
          </p>
        </div>
      </div>
    </section>
  );
}